module.exports = __webpack_public_path__ + "media/fonts/Oricons-047871df35934539956363b0bd8d5c1d.woff";